//由于权限key需要一个唯一的key值，路由的名字也需要一个唯一的key值，后端在模块添加页没有增加一个字段，因此两个功能用了同一个key值
import { marketing } from "./authCodeMap/marketing";
import { assets } from "./authCodeMap/assets";
import { dataCenter } from "./authCodeMap/dataCenter";
import { operation } from "./authCodeMap/operation";
import { ncme } from "./authCodeMap/ncme";
import { activity } from "./authCodeMap/activity";
import brand from "./authCodeMap/brand";
import { newCom } from "./authCodeMap/newCommunity";

const map = {
  ...marketing,
  ...assets,
  ...dataCenter,
  ...operation,
  ...ncme,
  ...brand,
  ...activity,
  ...newCom,
  layout: "layout", //骨架
  home: "home", // 首页
  hc_home: "hc_home", // 健康社区-首页
  doctor_community_home: "doctor_community_home", // 医生首页
  callback: "callback", // 绑定回调
  baseData: "baseData", //基础信息
  baseData_doctorManage: "baseData_doctorManage", // 医生管理
  doctor_baseData_doctorManage: "doctor_baseData_doctorManage", // 医生社区_医生管理
  doctor_baseData_doctorManage_add: "doctor_baseData_doctorManage_add", // 医生社区_医生管理-添加医生
  doctor_baseData_doctorManage_enterprise_add: "doctor_baseData_doctorManage_enterprise_add", // 医生社区_医生管理-添加医生
  doctor_baseData_doctorManage_hospital_add: "doctor_baseData_doctorManage_hospital_add", // 医生社区_医生管理-添加医生
  doctor_baseData_doctorManage_info: "doctor_baseData_doctorManage_info", // 医生社区_医生管理-医生详情
  health_baseData_doctorManage: "health_baseData_doctorManage", // 健康社区+医生管理
  baseData_doctorManage_joined: "baseData_doctorManage_joined", // 医生管理
  baseData_doctorManage_dataOverview: "baseData_doctorManage_dataOverview", // 医生数据分析
  baseData_doctorManage_dataOverview_export: "baseData_doctorManage_dataOverview_export", // 医生数据分析
  baseData_doctorManage_doctor: "baseData_doctorManage_doctor", // 医生管理_医生
  baseData_doctorManage_doctor_export: "baseData_doctorManage_doctor_export", // 活动管理_问答邀约_问答邀约管理_导出
  baseData_doctorManage_doctor_invite: "baseData_doctorManage_doctor_invite", // 活动管理_问答邀约_问答邀约管理_邀请
  baseData_doctorManage_doctor_link: "baseData_doctorManage_doctor_link", // 活动管理_问答邀约_问答邀约管理_邀请
  baseData_doctorManage_doctor_label: "baseData_doctorManage_doctor_label", // 活动管理_问答邀约_问答邀约管理_打标签
  baseData_doctorManage_doctor_delete: "baseData_doctorManage_doctor_delete", // 活动管理_问答邀约_问答邀约管理_打标签
  baseData_doctorManage_doctor_pass: "baseData_doctorManage_doctor_pass", // 活动管理_问答邀约_问答邀约管理_通过
  baseData_doctorManage_doctor_reject: "baseData_doctorManage_doctor_reject", // 活动管理_问答邀约_问答邀约管理_拒绝
  baseData_doctorManage_credit: "baseData_doctorManage_credit", // 医生管理_授信名单
  baseData_doctorManage_label: "baseData_doctorManage_label", // 医生管理_标签
  baseData_doctorManage_input: "baseData_doctorManage_input", // 医生管理_医生录入
  baseData_doctorManage_input_add: "baseData_doctorManage_input_add", // 医生管理_医生录入_新增
  baseData_doctorManage_input_edit: "baseData_doctorManage_input_edit", // 医生管理_医生录入_编辑
  baseData_doctorManage_input_good_edit: "baseData_doctorManage_input_good_edit", // 医生管理_医生录入_商品_编辑
  baseData_doctorManage_input_delete: "baseData_doctorManage_input_delete", // 医生管理_医生录入_删除
  baseData_doctorManage_input_detail: "baseData_doctorManage_input_detail", // 医生管理_医生录入_查看
  baseData_doctorManage_input_bind: "baseData_doctorManage_input_bind", // 医生管理_医生录入_绑定入驻医生
  baseData_doctorManage_input_online: "baseData_doctorManage_input_online", // 医生管理_医生录入_上线/下线
  baseData_doctorManage_registry: "baseData_doctorManage_registry", // 医生管理_医生注册
  baseData_doctorManage_to_auth: "baseData_doctorManage_to_auth", // 医生管理_去认证
  baseData_doctorManage_operation_allocation: "baseData_doctorManage_operation_allocation", // 医生管理_代运营
  baseData_doctorManage_distribution: "baseData_doctorManage_distribution", // 代运营分配
  baseData_doctorManage_distribution_health: "baseData_doctorManage_distribution_health", // 代运营分配
  baseData_doctorManage_distribution_doctor: "baseData_doctorManage_distribution_doctor", // 代运营分配
  baseData_doctorManage_distribution_operation: "baseData_doctorManage_distribution_operation", // 代运营分配_分配
  baseData_doctorManage_export: "baseData_doctorManage_export", // 代运营分配_导出

  baseData_doctorManage_label_edit: "baseData_doctorManage_label_edit", // 医生管理_标签_编辑
  baseData_doctorManage_label_delete: "baseData_doctorManage_label_delete", // 医生管理_标签_删除
  baseData_doctorManage_label_add: "baseData_doctorManage_label_add", // 医生管理_标签_删除
  baseData_userManage: "baseData_userManage", // 医生管理
  baseData_userManage_user: "baseData_userManage_user", // 医生管理_注册用户
  baseData_userManage_user_label: "baseData_userManage_user_label", // 医生管理_注册用户_打标签
  baseData_userManage_user_delete: "baseData_userManage_user_delete", // 医生管理_注册用户_删除

  baseData_visitManage_visit: "baseData_visitManage_visit", // 医生管理_就诊用户
  baseData_visitManage_visit_label: "baseData_visitManage_visit_label", // 医生管理_就诊用户_打标签
  baseData_visitManage_visit_delete: "baseData_visitManage_visit_delete", // 医生管理_就诊用户_删除

  // 新医生管理
  health_baseData_doctorManageMent: "health_baseData_doctorManageMent", // 健康社区-医生管理
  doctor_baseData_doctorManageMent: "doctor_baseData_doctorManageMent", // 医生社区-医生管理
  baseData_doctorManageMent_list: "baseData_doctorManageMent_list", // 医生列表
  baseData_doctorManageMent_entey_doctor: "baseData_doctorManageMent_entey_doctor", // 录入医生
  baseData_doctorManageMent_invite_doctor: "baseData_doctorManageMent_invite_doctor", // 邀请医生
  baseData_doctorManageMent_import_doctor: "baseData_doctorManageMent_import_doctor", // 导入医生
  baseData_doctorManageMent_export_doctor: "baseData_doctorManageMent_export_doctor", // 导出医生
  baseData_doctorManageMent_online_doctor: "baseData_doctorManageMent_online_doctor", // 上架
  baseData_doctorManageMent_offline_doctor: "baseData_doctorManageMent_offline_doctor", // 下架
  baseData_doctorManageMent_distribute_label: "baseData_doctorManageMent_distribute_label", // 分配标签
  baseData_doctorManageMent_add_label: "baseData_doctorManageMent_add_label", // 加标签
  baseData_doctorManageMent_edit_doctor: "baseData_doctorManageMent_edit_doctor", // 编辑
  baseData_doctorManageMent_delete_doctor: "baseData_doctorManageMent_delete_doctor", // 删除
  baseData_doctorManageMent_shortMessage_invite: "baseData_doctorManageMent_shortMessage_invite", // 短信邀请
  baseData_doctorManageMent_relevance_goods: "baseData_doctorManageMent_relevance_goods", //关联商品

  baseData_doctorManageMent_check_in_review: "baseData_doctorManageMent_check_in_review", // 入驻审核
  baseData_doctorManageMent_pass_through: "baseData_doctorManageMent_pass_through", // 通过
  baseData_doctorManageMent_reject: "baseData_doctorManageMent_reject", // 拒绝

  baseData_doctorManageMent_invitationRecord: "baseData_doctorManageMent_invitationRecord", // 邀约记录

  baseData_userManage_tourist: "baseData_userManage_tourist", // 医生管理_普通用户
  baseData_userManage_tourist_delete: "baseData_userManage_tourist_delete", // 医生管理_普通用户
  baseData_userManage_label: "baseData_userManage_label", // 医生管理_用户标签
  baseData_userManage_label_edit: "baseData_userManage_label_edit", // 医生管理_用户标签_编辑
  baseData_userManage_label_delete: "baseData_userManage_label_delete", // 医生管理_用户标签_编辑
  baseData_userManage_label_add: "baseData_userManage_label_add", // 医生管理_用户标签_编辑
  baseData_doctorDetail: "baseData_doctorDetail", // 医生详情
  baseData_organizationManage: "baseData_organizationManage", // 基础数据_机构管理
  baseData_organizationManage_add: "baseData_organizationManage_add", // 基础数据_机构管理_新增机构
  baseData_organizationManage_copy: "baseData_organizationManage_copy", // 基础数据_机构管理_复制链接
  baseData_organizationManage_upload: "baseData_organizationManage_upload", // 基础数据_机构管理_批量导入
  baseData_organizationManage_groupDelete: "baseData_organizationManage_groupDelete", // 基础数据_机构管理_批量删除
  baseData_organizationManage_groupOnline: "baseData_organizationManage_groupOnline", // 基础数据_机构管理_批量上下线
  baseData_organizationManage_share: "baseData_organizationManage_share", // 基础数据_机构管理_分享
  baseData_organizationManage_visit: "baseData_organizationManage_visit", // 基础数据_机构管理_分享
  baseData_organizationManage_edit: "baseData_organizationManage_edit", // 基础数据_机构管理_修改
  baseData_organizationManage_off: "baseData_organizationManage_off", // 基础数据_机构管理_下架
  baseData_organizationManage_manageDoctor: "baseData_organizationManage_manageDoctor", // 基础数据_机构管理_管理专业人士
  baseData_organizationManage_manageAc: "baseData_organizationManage_manageAc", // 基础数据_机构管理_管理专业人士
  baseData_organizationManage_delete: "baseData_organizationManage_delete", // 基础数据_机构管理_删除
  baseData_organizationEdit: "baseData_organizationEdit", // 基础数据_机构管理_编辑
  baseData_organizationActiveManage: "baseData_organizationActiveManage", // 基础数据_机构管理_活动管理
  baseData_organizationDoctorManage: "baseData_organizationDoctorManage", // 基础数据_机构管理_医生管理
  baseData_organizationDetails: "baseData_organizationDetails", // 基础数据_机构管理_详情
  baseData_organizationDetails_vest: "baseData_organizationDetails_vest", // 基础数据_马甲管理
  baseData_organizationDetails_vest_add: "baseData_organizationDetails_vest_add", // 基础数据_马甲管理_添加
  baseData_organizationDetails_vest_edit: "baseData_organizationDetails_vest_edit", // 基础数据_马甲管理_编辑
  baseData_organizationDetails_vest_del: "baseData_organizationDetails_vest_del", // 基础数据_马甲管理_删除
  financeManage_finance: "financeManage_finance", // 财务管理
  financeManage_finance_charge: "financeManage_finance_charge", // 财务管理_ c充值
  financeManage_finance_download: "financeManage_finance_download", // 财务管理_导出数据
  financeManage_finance_detail: "financeManage_finance_detail", // 财务管理_查看付款信息
  basicSetting: "basicSetting", // 基础设置
  common_login: "common_login", // 登录
  common_create: "common_create", // 登录
  community_list: "communityList", // 社区列表
  basicSetting_account: "basicSetting_account", // 基本设置_成员管理
  basicSetting_account_add: "basicSetting_account_add", // 基本设置_成员管理添加成员
  basicSetting_account_edit: "basicSetting_account_edit", // 基本设置_成员管理编辑
  basicSetting_account_delete: "basicSetting_account_delete", // 基本设置_成员管理_移除
  basicSetting_setting_doctorActivity: "basicSetting_setting_doctorActivity", // 基本设置_编辑
  basicSetting_setting_doctorActivity_save: "basicSetting_setting_doctorActivity_save", // 基本设置_编辑
  basicSetting_setting_doctorJoinComunnity: "basicSetting_setting_doctorJoinComunnity", // 基本设置_编辑
  basicSetting_setting: "basicSetting_setting", // 基本设置_编辑
  basicSetting_setting_save: "basicSetting_setting_save", // 基本设置_编辑_保存
  basicSetting_news: "basicSetting_news", // 基本设置_消息中心
  basicSetting_permission: "basicSetting_permission", // 基本设置_权限管理
  basicSetting_role: "basicSetting_role", // 基本设置_角色管理
  basicSetting_role_add: "basicSetting_role_add", // 基本设置_角色管理_添加角色
  basicSetting_role_look: "basicSetting_role_look", // 基本设置_角色管理_查看
  basicSetting_role_edit: "basicSetting_role_edit", // 基本设置_角色管理_编辑
  basicSetting_role_delete: "basicSetting_role_delete", // 基本设置_角色管理_删除
  basicSetting_addRole: "basicSetting_addRole", // 基本设置_角色管理_管理
  basicSetting_bind: "basicSetting_bind", // 基本设置_绑定
  basicSetting_bind_weibo_bind: "basicSetting_bind_weibo_bind", // 基本设置_微博绑定
  basicSetting_bind_weibo_mainaccount: "basicSetting_bind_weibo_mainaccount", // 基本设置_微博_主账号
  basicSetting_bind_weixin_bind: "basicSetting_bind_weixin_bind", // 基本设置_微博绑定
  basicSetting_bind_unweibo: "basicSetting_bind_unweibo", // 基本设置_微信绑定
  basicSetting_bind_rebind: "basicSetting_bind_rebind", // 基本设置_绑定_再授权
  basicSetting_bind_unwechat: "basicSetting_bind_unwechat", // 基本设置_公众号解绑

  basicSetting_agreement: "basicSetting_agreement", // 基本设置_

  operationsManage: "operationsManage", // 运营管理
  operationsManage_postBar: "operationsManage_postBar", // 运营管理_圈子论坛
  operationsManage_postBar_post: "operationsManage_postBar_post", // 运营管理_圈子论坛_帖子
  operationsManage_postBar_post_add: "operationsManage_postBar_post_add", // 运营管理_圈子论坛_帖子_新建帖子
  operationsManage_postBar_post_setTop: "operationsManage_postBar_post_setTop", // 运营管理_圈子论坛_帖子_ 置顶/取消置顶
  operationsManage_postBar_post_recommend: "operationsManage_postBar_post_recommend", // 运营管理_圈子论坛_帖子_推荐/取消推荐
  operationsManage_postBar_post_online: "operationsManage_postBar_post_online", // 运营管理_圈子论坛_帖子_上线/下线
  operationsManage_postBar_post_edit: "operationsManage_postBar_post_edit", // 运营管理_圈子论坛_帖子_编辑（仅限本账号发布的帖子
  operationsManage_postBar_post_share: "operationsManage_postBar_post_share", // 运营管理_圈子论坛_帖子_分享
  operationsManage_siteMsg: "operationsManage_siteMsg", // 运营管理站内信管理
  operationsManage_siteMsg_add: "operationsManage_siteMsg_add", // 运营管理站内信管理_添加
  operationsManage_siteMsg_delete: "operationsManage_siteMsg_delete", // 运营管理站内信管理_删除

  operationsManage_postBar_topic: "operationsManage_postBar_topic", // 运营管理_圈子论坛_话题
  operationsManage_postBar_topic_export: "operationsManage_postBar_topic_export", // 运营管理_圈子论坛_话题_导出
  operationsManage_postBar_topic_add: "operationsManage_postBar_topic_add", // 运营管理_圈子论坛_话题_新建话题
  operationsManage_postBar_topic_recommend: "operationsManage_postBar_topic_recommend", // 运营管理_圈子论坛_话题_推荐/取消推荐
  operationsManage_postBar_topic_online: "operationsManage_postBar_topic_online", // 运营管理_圈子论坛_话题_上线/下线
  operationsManage_postBar_topic_edit: "operationsManage_postBar_topic_edit", // 运营管理_圈子论坛_话题_编辑
  operationsManage_postBar_topic_share: "operationsManage_postBar_topic_share", // 运营管理_圈子论坛_话题_分享

  operationsManage_postBar_commend: "operationsManage_postBar_commend", // 运营管理_圈子论坛_评论
  operationsManage_postBar_commend_response: "operationsManage_postBar_commend_response", // 运营管理_圈子论坛_评论_回复
  operationsManage_postBar_commend_block: "operationsManage_postBar_commend_block", // 运营管理_圈子论坛_评论_屏蔽/取消屏蔽

  operationsManage_postBar_editPost: "operationsManage_postBar_editPost", // 运营管理_圈子论坛_帖子

  operationsManage_advertisementManage: "operationsManage_advertisementManage", // 运营管理_广告管理
  operationManage_advertManage: "operationManage_advertManage", // 运营管理_广告管理
  operationManage_advertManage_manage: "operationManage_advertManage_manage", // 运营管理_广告管理
  operationManage_advertManage_manage_homeAdvert: "operationManage_advertManage_manage_homeAdvert", // 运营管理_广告管理_首页
  operationManage_advertManage_manage_healthCircleAdvert: "operationManage_advertManage_manage_healthCircleAdvert", // 运营管理_广告管理_首页
  operationManage_advertManage_manage_articleDetailsAdvert: "operationManage_advertManage_manage_articleDetailsAdvert", // 运营管理_广告管理_首页
  operationManage_advertManage_manage_postDetailsAdvert: "operationManage_advertManage_manage_postDetailsAdvert", // 运营管理_广告管理_首页
  operationManage_advertManage_manage_shareDetailsAdvert: "operationManage_advertManage_manage_shareDetailsAdvert", // 运营管理_广告管理_首页
  operationManage_advertManage_data: "operationManage_advertManage_data", // 运营管理_广告管理
  operationManage_advertManage_export: "operationManage_advertManage_export", // 运营管理_广告管理_导出
  operationManage_advertManage_submit: "operationManage_advertManage_submit", // 运营管理_广告管理_提交
  operationManage_advertManage_save: "operationManage_advertManage_save", // 运营管理_广告管理_保存预览
  operationManage_pointManage: "operationManage_pointManage", //积分管理
  operationManage_pointManage_changeState: "operationManage_pointManage_changeState", //积分管理-关闭/开启积分功能
  operationManage_pointManage_export: "operationManage_pointManage_export", //积分管理-导出
  operationManage_pointsMallEdit: "operationManage_pointsMallEdit", //积分管理商品编辑
  operationManage_pointsMallList: "operationManage_pointsMallList", //积分管理列表
  operationManage_pointsMallList_add: "operationManage_pointsMallList_add", //积分管理列表_新增
  operationManage_pointsMallList_export: "operationManage_pointsMallList_export", //积分管理列表_导出
  operationManage_pointsMallList_onandoff: "operationManage_pointsMallList_onandoff", //积分管理列表_导出_上下架
  operationManage_pointsMallList_edit: "operationManage_pointsMallList_edit", //积分管理列表_导出_上下架

  operationManage_pointDetail: "operationManage_pointDetail", // 积分明细
  operationsManage_pointDetail_pointIncomeDetail: "operationsManage_pointDetail_pointIncomeDetail", // 积分明细-积分获取密西
  operationsManage_pointDetail_pointIncomeDetail_export: "operationsManage_pointDetail_pointIncomeDetail_export", // 积分明细-积分获取密西_导出
  operationsManage_pointDetail_goodsChangeDetail: "operationsManage_pointDetail_goodsChangeDetail", // 积分明细-商品兑换明细
  operationsManage_pointDetail_goodsChangeDetail_export: "operationsManage_pointDetail_goodsChangeDetail_export", // 积分明细-商品兑换明细-导出
  operationsManage_pointDetail_goodsChangeDetail_sendGoods: "operationsManage_pointDetail_goodsChangeDetail_sendGoods", // 积分明细-商品兑换明细-发货
  operationsManage_pointDetail_goodsChangeDetail_checkDetail: "operationsManage_pointDetail_goodsChangeDetail_checkDetail", // 积分明细-商品兑换明细-发货详情

  // community_tieba: "community_tieba", // 运营管理_圈子论坛
  community: "community", // 运营管理
  // community_index: "community_index", // 社区首页
  community_deco: "community_deco", // 社区装修聚合页

  community_deco_index: "community_deco_index", // 社区装修聚合页_首页
  community_deco_index_share: "community_deco_index_share", // 社区装修聚合页_首页_分享
  community_deco_index_submit: "community_deco_index_submit", // 社区装修聚合页_首页_提交
  community_deco_index_preview: "community_deco_index_preview", // 社区装修聚合页_首页_预览
  community_deco_index_comty_info: "community_deco_index_comty_info", // 装修-社区信息
  community_deco_index_comty_info_update: "community_deco_index_comty_info_update", // 装修-社区信息--去修改
  community_deco_index_shop_info_update: "community_deco_index_shop_info_update", // 装修-社区信息-零售商信息-去修改
  community_deco_index_on_off_line: "community_deco_index_on_off_line", // 社区装修聚合页_首页_上下线
  community_deco_tieba: "community_deco_tieba", // 社区装修聚合页_健康圈装修
  community_deco_tieba_submit: "community_deco_tieba_submit", // 社区装修聚合页_健康圈装修_提交
  community_audit: "community_audit", // 社区审核
  community_info: "community_info", //社区信息
  health_community_info: "health_community_info", //社区信息
  doctor_community_info: "doctor_community_info", //社区信息
  community_register: "community_register", //社区信息
  community_lastinfo: "community_lastinfo", //社区审核中信息

  content: "content", // 内容管理
  content_classify: "content_classify", // 内容管理-分类管理
  content_classify_add: "content_classify_add", // 内容管理-分类管理_新建分类
  content_classify_online: "content_classify_online", // 内容管理-分类管理_上线/下线（切换状态）
  content_classify_sort: "content_classify_sort", // 内容管理-分类管理_排序（上调/下调）
  content_classify_edit: "content_classify_edit", // 内容管理-分类管理_编辑
  content_classify_delete: "content_classify_delete", // 内容管理-分类管理_删除

  content_allEdit: "content_allEdit", // 内容管理-新建文章
  content_label: "content_label", // 内容管理-标签管理
  content_label_add: "content_label_add", // 内容管理-标签管理_新建分类
  content_label_online: "content_label_online", // 内容管理-标签管理_上线/下线（切换状态）
  content_label_edit: "content_label_edit", // 内容管理-标签管理_编辑
  content_label_delete: "content_label_delete", // 内容管理-标签管理_删除
  content_allIndex: "content_allIndex", // 内容管理-全部详情
  content_popularLive: "content_popularLive", // 内容管理-科普文章
  content_allIndex_add: "content_allIndex_add", // 内容管理-新建
  content_allIndex_export: "content_allIndex_export", // 内容管理-全部详情_导出
  content_allIndex_award: "content_allIndex_award", // 内容管理-全部详情_奖励/撤回奖励/奖励详情
  content_allIndex_online: "content_allIndex_online", // 内容管理-全部详情_上线/下线
  content_allIndex_edit: "content_allIndex_edit", // 内容管理-全部详情_编辑
  content_allIndex_share: "content_allIndex_share", // 内容管理-全部详情_分享
  content_allIndex_classify: "content_allIndex_classify", // 内容管理-全部详情_分类
  content_allIndex_tag: "content_allIndex_tag", // 内容管理-全部详情_标签

  content_clinic: "content_clinic", // 内容管理-诊室文章

  content_liveCollection: "content_liveCollection", //内容管理-直播采集
  content_liveCollection_waiting: "content_liveCollection_waiting", //内容管理-直播采集-待筛选
  content_liveCollection_waiting_collection: "content_liveCollection_waiting_collection", //内容管理-直播采集-待筛选-采集
  content_liveCollection_waiting_visit: "content_liveCollection_waiting_visit", //内容管理-直播采集-待筛选-访问
  content_liveCollection_waiting_reject: "content_liveCollection_waiting_reject", //内容管理-直播采集-待筛选-拒绝
  content_liveCollection_accept: "content_liveCollection_accept", //内容管理-直播采集-已采集
  content_liveCollection_accept_visit: "content_liveCollection_accept_visit", //内容管理-直播采集-已采集-访问
  content_liveCollection_reject: "content_liveCollection_reject", //内容管理-直播采集-已拒绝
  content_liveCollection_reject_visit: "content_liveCollection_reject_visit", //内容管理-直播采集-已拒绝-访问

  content_clinic_waiting: "content_clinic_waiting", // 内容管理-诊室文章_待筛选
  content_clinic_waiting_accept: "content_clinic_waiting_accept", // 内容管理-诊室文章_待筛选_采纳
  content_clinic_waiting_reject: "content_clinic_waiting_reject", // 内容管理-诊室文章_待筛选_拒绝
  content_clinic_waiting_export: "content_clinic_waiting_export", // 内容管理-诊室文章_待筛选_导出

  content_clinic_accept: "content_clinic_accept", // 内容管理-诊室文章_已采纳
  content_clinic_accept_export: "content_clinic_accept_export", // 内容管理-诊室文章_已采纳_导出
  content_clinic_accept_online: "content_clinic_accept_online", // 内容管理-诊室文章_已采纳_上线/下线
  content_clinic_accept_reward: "content_clinic_accept_reward", // 内容管理-诊室文章_已采纳_奖励/撤回奖励/奖励详情
  content_clinic_accept_label: "content_clinic_accept_label", // 内容管理-诊室文章_已采纳_修改标签
  content_clinic_accept_groupLabel: "content_clinic_accept_groupLabel", // 内容管理-诊室文章_已采纳_批量修改标签
  content_clinic_accept_classify: "content_clinic_accept_classify", // 内容管理-诊室文章_已采纳_修改分类
  content_clinic_accept_groupClassify: "content_clinic_accept_groupClassify", // 内容管理-诊室文章_已采纳_批量修改分类

  content_clinic_reject: "content_clinic_reject", // 内容管理-诊室文章_已拒绝
  content_clinic_reject_delete: "content_clinic_reject_delete", // 内容管理-诊室文章_已拒绝_删除
  content_clinic_reject_export: "content_clinic_reject_export", // 内容管理-诊室文章_已拒绝_导出

  content_special_topic: "content_special_topic", // 内容管理-诊室文章
  content_special_topic_edit: "content_special_topic_edit",
  content_special_topic_add: "content_special_topic_add",
  content_special_topic_online: "content_special_topic_online",
  content_special_topic_recommend: "content_special_topic_recommend",
  content_special_topic_delete: "content_special_topic_delete",

  content_qa: "content_qa", // 内容管理-问答管理
  content_qa_question: "content_qa_question", // 内容管理-问题管理
  content_qa_question_export: "content_qa_question_export", // 内容管理-导出
  content_qa_question_edit: "content_qa_question_edit", // 内容管理-编辑
  content_qa_question_recommend: "content_qa_question_recommend", // 内容管理-推荐/取消推荐
  content_qa_question_online: "content_qa_question_online", // 内容管理-上线/下线
  content_qa_question_share: "content_qa_question_share", // 内容管理-分享
  content_qa_anwser: "content_qa_anwser", // 内容管理-回答管理
  content_qa_anwser_online: "content_qa_anwser_online", // 内容管理-回答管理-上线/下线
  content_qa_comment: "content_qa_comment", // 内容管理-评论管理
  content_qa_comment_cancel: "content_qa_comment_cancel", // 内容管理-评论管理_屏蔽/取消屏蔽

  content_live: "content_live", //科普直播
  content_live_add: "content_live_add", //创建直播
  content_live_online: "content_live_online", //上下线
  content_live_visit: "content_live_visit", //访问
  content_live_edit: "content_live_edit", //编辑
  content_live_delete: "content_live_delete", //编辑

  activityManage: "activtyManage", //活动管理
  activityManage_invite_add: "activityManage_invite_add", // 活动管理_内容邀约_新建邀约
  activityManage_invite_detail: "InviteDetails", // 活动管理_内容邀约_邀约详情

  activityManage_qsInvite: "activityManage_qsInvite", // 活动管理_问答邀约

  activityManage_qsInvite_qsInvite: "activityManage_qsInvite_qsInvite", // 活动管理_问答邀约_问答邀约管理
  activityManage_qsInvite_qsInvite_add: "activityManage_qsInvite_qsInvite_add", // 活动管理_问答邀约_问答邀约管理_新建邀约
  activityManage_qsInvite_qsInvite_export: "activityManage_qsInvite_qsInvite_export", // 活动管理_问答邀约_问答邀约管理_导出
  activityManage_qsInvite_qsInvite_edit: "activityManage_qsInvite_qsInvite_edit", // 活动管理_问答邀约_问答邀约管理_编辑（针对未开始的邀约）
  activityManage_qsInvite_qsInvite_filter: "activityManage_qsInvite_qsInvite_filter", // 活动管理_问答邀约_问答邀约管理_筛选
  activityManage_qsInvite_qsInvite_close: "activityManage_qsInvite_qsInvite_close", // 活动管理_问答邀约_问答邀约管理_结束邀约

  activityManage_qsInvite_qsFiltrate: "activityManage_qsInvite_qsFiltrate", // 活动管理_问答邀约_待筛选
  activityManage_qsInvite_qsFiltrate_accept: "activityManage_qsInvite_qsFiltrate_accept", // 活动管理_问答邀约_待筛选_采纳
  activityManage_qsInvite_qsFiltrate_reject: "activityManage_qsInvite_qsFiltrate_reject", // 活动管理_问答邀约_待筛选_拒绝

  activityManage_qsInvite_qsAccept: "activityManage_qsInvite_qsAccept", // 活动管理_问答邀约_已采纳
  activityManage_qsInvite_qsAccept_recall: "activityManage_qsInvite_qsAccept_recall", // 活动管理_问答邀约_已采纳_撤回采纳
  activityManage_qsInvite_qsAccept_reward: "activityManage_qsInvite_qsAccept_reward", // 活动管理_问答邀约_已采纳_奖励/奖励详情/撤回奖励

  activityManage_qsInvite_qsRefused: "activityManage_qsInvite_qsRefused", // 活动管理_问答邀约_已拒绝
  activityManage_qsInvite_qsRefused_recall: "activityManage_qsInvite_qsRefused_recall", // 活动管理_问答邀约_已拒绝_撤回拒绝
  activityManage_qsInvite_qsRefused_delete: "activityManage_qsInvite_qsRefused_delete", // 活动管理_问答邀约_已拒绝_删除

  activityManage_contentInvite: "activityManage_contentInvite", // 活动管理_内容邀约

  activityManage_contentInvite_inviteManage: "activityManage_contentInvite_inviteManage", // 活动管理_内容邀约_内容邀约管理
  activityManage_contentInvite_inviteManage_add: "activityManage_contentInvite_inviteManage_add", // 活动管理_内容邀约_新建邀约
  activityManage_contentInvite_inviteManage_export: "activityManage_contentInvite_inviteManage_export", // 活动管理_内容邀约_导出
  activityManage_contentInvite_inviteManage_edit: "activityManage_contentInvite_inviteManage_edit", // 活动管理_内容邀约_编辑
  activityManage_contentInvite_inviteManage_filter: "activityManage_contentInvite_inviteManage_filter", // 活动管理_内容邀约_筛选
  activityManage_contentInvite_inviteManage_close: "activityManage_contentInvite_inviteManage_close", // 活动管理_内容邀约_结束邀约
  activityManage_contentInvite_inviteManage_copy: "activityManage_contentInvite_inviteManage_copy", // 活动管理_内容邀约_复制活动
  activityManage_contentInvite_inviteManage_closePub: "activityManage_contentInvite_inviteManage_closePub", // 活动管理_内容邀约_关闭投递

  activityManage_contentInvite_screen: "activityManage_contentInvite_screen", // 活动管理_内容邀约_待筛选
  activityManage_contentInvite_screen_export: "activityManage_contentInvite_screen_export", // 活动管理_内容邀约_待筛选
  activityManage_contentInvite_screen_accept: "activityManage_contentInvite_screen_accept", // 活动管理_内容邀约_待筛选_采纳
  activityManage_contentInvite_screen_multiAccept: "activityManage_contentInvite_screen_multiAccept", // 活动管理_内容邀约_待筛选_批量采纳
  activityManage_contentInvite_screen_reject: "activityManage_contentInvite_screen_reject", // 活动管理_内容邀约_待筛选_拒绝
  activityManage_contentInvite_screen_cnki: "activityManage_contentInvite_screen_cnki", // 活动管理_内容邀约_待筛选_查重

  activityManage_contentInvite_adopted: "activityManage_contentInvite_adopted", // 活动管理_内容邀约_已采纳
  activityManage_contentInvite_adopted_export: "activityManage_contentInvite_adopted_export", // 活动管理_内容邀约_已采纳_导出
  activityManage_contentInvite_adopted_recall: "activityManage_contentInvite_adopted_recall", // 活动管理_内容邀约_已采纳_撤回采纳
  activityManage_contentInvite_adopted_reward: "activityManage_contentInvite_adopted_reward", // 活动管理_内容邀约_已采纳_奖励
  activityManage_contentInvite_adopted_online: "activityManage_contentInvite_adopted_online", // 活动管理_内容邀约_已采纳_上线/下线
  activityManage_contentInvite_adopted_label: "activityManage_contentInvite_adopted_label", // 活动管理_内容邀约_已采纳_修改标签
  activityManage_contentInvite_adopted_classify: "activityManage_contentInvite_adopted_classify", // 活动管理_内容邀约_已采纳_修改分类
  activityManage_contentInvite_adopted_editGradeId: "activityManage_contentInvite_adopted_editGradeId", // 活动管理_内容邀约_已采纳_修分级
  activityManage_contentInvite_adopted_gradeReward: "activityManage_contentInvite_adopted_gradeReward", // 活动管理_内容邀约_已采纳_等级_撤回发放
  activityManage_contentInvite_adopted_multiClassify: "activityManage_contentInvite_adopted_multiClassify", // 活动管理_内容邀约_已采纳_批量分配分类
  activityManage_contentInvite_adopted_multiLabel: "activityManage_contentInvite_adopted_multiLabel", // 活动管理_内容邀约_已采纳_批量分配标签
  activityManage_contentInvite_adopted_multiOnline: "activityManage_contentInvite_adopted_multiOnline", // 活动管理_内容邀约_已采纳_批量上线
  activityManage_contentInvite_adopted_multiOffline: "activityManage_contentInvite_adopted_multiOffline", // 活动管理_内容邀约_已采纳_批量下线
  activityManage_contentInvite_adopted_multiGradeReward: "activityManage_contentInvite_adopted_multiGradeReward", // 活动管理_内容邀约_已采纳_批量发放稿费
  activityManage_contentInvite_adopted_multiReward: "activityManage_contentInvite_adopted_multiReward", // 活动管理_内容邀约_已采纳_批量发放额外奖励

  activityManage_contentInvite_rejected: "activityManage_contentInvite_rejected", // 活动管理_内容邀约_已拒绝
  activityManage_contentInvite_rejected_export: "activityManage_contentInvite_rejected_export", // 活动管理_内容邀约_已拒绝_导出
  activityManage_contentInvite_rejected_recall: "activityManage_contentInvite_rejected_recall", // 活动管理_内容邀约_已拒绝_撤回拒绝
  activityManage_contentInvite_rejected_delete: "activityManage_contentInvite_rejected_delete", // 活动管理_内容邀约_已拒绝_删除

  activityManage_landingPage: "activityManage_landingPage", // 活动管理_落地页管理
  activityManage_landingPage_add: "activityManage_landingPage_add", // 活动管理_落地页管理_新建
  activityManage_landingPage_edit: "activityManage_landingPage_edit", // 活动管理_落地页管理_编辑
  activityManage_landingPage_guide: "activityManage_landingPage_guide", // 活动管理_落地页管理_帮助文档
  activityManage_landingPage_visit: "activityManage_landingPage_visit", // 活动管理_落地页管理_访问也面
  activityManage_landingPage_share: "activityManage_landingPage_share", // 活动管理_落地页管理_分享
  activityManage_landingPage_online: "activityManage_landingPage_online", // 活动管理_落地页管理_上/下线
  activityManage_landingPage_groupOnline: "activityManage_landingPage_groupOnline", // 活动管理_落地页管理_上/下线
  activityManage_voteManage_index: "activityManage_voteManage_index", // 活动管理_投票页管理_上/下线
  activityManage_voteManage_index_add: "activityManage_voteManage_index_add", // 活动管理_投票页管理_发起投票
  activityManage_voteManage_index_edit: "activityManage_voteManage_index_edit", // 活动管理_投票页管理_编辑
  activityManage_voteManage_index_look: "activityManage_voteManage_index_look", // 活动管理_投票页管理_查看

  operationTools: "operationTools", //运营工具
  operationTools_questionnaire: "operationTools_questionnaire", // 问卷管理
  questionnaire_answerSheetPage: "questionnaire_answerSheetPage", //问卷答卷管理
  questionnaire_answerSheetDetail: "questionnaire_answerSheetDetail", //问卷答卷详情
  operationTools_measurementHeight: "operationTools_measurementHeight", //身高测评
  operationTools_measurementHeight_dataList: "operationTools_measurementHeight_dataList", // 数据列表
  operationTools_measurementHeight_detail: "operationTools_measurementHeight_detail", // 详情页面

  marketing: "marketing",
  invite_acticity_manage: "invite_acticity_manage",
  activity_registration: "activity_registration",
  activity_registration_sign: "activity_registration_sign",
  activity_registration_detail: "activity_registration_detail",
  activity_registration_order: "activity_registration_order",
  activity_registration_edit: "activity_registration_edit",
  order_record: "order_record",
  grade_management: "grade_management",
  city_budget: "city_budget", //运营-城市预算
  city_budget_add: "city_budget_add",
  city_budget_detail: "city_budget_detail",
  city_budget_enable_disable: "city_budget_enable_disable",
  city_budget_view: "city_budget_view",
  city_budget_edit: "city_budget_edit",

  brand: "brand",
  brand_case_collection: "brand_case_collection",
  brand_case_activity: "brand_case_activity",
  brand_case_activity_add: "brand_case_activity_add",
  brand_case_activity_edit: "brand_case_activity_edit",
  brand_case_activity_end: "brand_case_activity_end",
  brand_case_activity_copyEdit: "brand_case_activity_copyEdit",
  brand_case_activity_visit: "brand_case_activity_visit",
  brand_case_activity_copy: "brand_case_activity_copy",
  brand_case_activity_Detail: "brand_case_activity_Detail",
  brand_case_manager: "brand_case_manager",
  brand_case_manager_adopt: "brand_case_manager_adopt",
  brand_case_manager_refuse: "brand_case_manager_refuse",
  brand_case_manager_cancel_adopt: "brand_case_manager_cancel_adopt",
  brand_case_manager_high: "brand_case_manager_high",
  brand_case_manager_recall_high: "brand_case_manager_recall_high",
  brand_case_manager_high_detail: "brand_case_manager_high_detail",
  brand_case_manager_online: "brand_case_manager_online",
  brand_case_manager_delete: "brand_case_manager_delete",

  transaction: "transaction",
  transaction_goods_management: "transaction_goods_management", // 交易_商品管理
  transaction_goods_management_add: "transaction_goods_management_add", // 交易_添加
  transaction_goods_management_groupOnline: "transaction_goods_management_groupOnline", // 交易_批量group
  transaction_goods_management_sync: "transaction_goods_management_sync", // 交易_批量group_sync
  transaction_goods_management_edit: "transaction_goods_management_edit", // 交易_编辑
  transaction_goods_management_online: "transaction_goods_management_online", // 交易_上架/下架
  transaction_goods_management_delete: "transaction_goods_management_delete", // 交易_删除
  transaction_clue_management: "transaction_clue_management", // 交易_线索管理
  transaction_clue_management_detail: "transaction_clue_management_detail", // 交易_线索管理_详情
  transaction_clue_management_edit: "transaction_clue_management_edit", // 交易_线索管理_编辑
  transaction_consumption_management: "transaction_consumption_management", // 交易_消费管理
};

export default map;
